import type { HasSeenItKey, HasSeenPrefixedKey } from './types';

export const createHasSeenPrefixedKey = (key: HasSeenItKey): HasSeenPrefixedKey => {
	return `hasSeen-${key}`;
};
